<p>popup-referred-profileupdated works!</p>
